<template>
    <div class="ba6-account-info ba-card ba-w-100">
        <div class="ba-top">
          <span class="ba-title" v-text="t.office2_geral_edit_info"></span>
          <div class="ba-box-items ba-flex ba-gp-1">
            <button :class="['ba-btn', 'ba-sm', 'ba-blue', loading || !validateGeralForm ? 'ba-disabled' : '']" :disabled="loading || !validateGeralForm" @click="saveForm()">{{ t.save }}</button>
          </div>
        </div>
        <builderall-loader class="ba-content ba-w-100" :loading="loading">
            <div class='ba-box-input ba-md'>
                <div class='ba-info'>
                    <div class='ba-info-left'>
                        <label class='ba-label' for='name'>{{ t.label_first_last_name_edit_account }}</label>
                    </div>
                </div>
                <input type='text' id='name' v-model="form.name" :class="['ba-input', nameHasErrors ? 'ba-error' : '']" :placeholder=' t.enter_first_last_name ' pattern="[0-9-A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$" />
            </div>
            <br>
            <div class='ba-box-input ba-md'>
                <!-- Modal Change Email -->
                <ba6-modal modal-id="ba6-modal-change-email">
                    <div class='ba-card ba-w-100 ba-no-shadow'>
                        <div class='ba-top'>
                            <span class='ba-title'>{{ t.office2_info_modal_change_email_title }}</span>
                            <div class='ba-box-items ba-flex ba-gp-1'>
                                <button class='ba-btn ba-btn-close ba-sm ba-rounded' @click="toggleModal('ba6-modal-change-email')">
                                    <builderall-icon code='64f7' />
                                </button>
                            </div>
                        </div>
                        <div class='ba-content ba-w-100 ba-flex ba-f-column ba-gp-2'>
                            <div class="ba-flex ba-jc-center">
                                <div class='ba-step'>
                                    <div class="ba-step-element ba-step-active" @click="stepModal = 1">
                                        <i class='ba-step-icon'>
                                            <builderall-icon code='dd8e'></builderall-icon>
                                        </i>
                                        <span class='ba-step-title'>{{ t.label_novo_email }}</span>
                                    </div>
                                    <div :class="['ba-step-element', stepModal > 1 ? 'ba-step-active' : '']" @click="stepModal > 1 ? stepModal = 2 : ''">
                                        <i class='ba-step-icon'>
                                            <builderall-icon code='dd8e'></builderall-icon>
                                        </i>
                                        <span class='ba-step-title'>{{ t.label_codigo }}</span>
                                    </div>
                                    <div :class="['ba-step-element', stepModal > 2 ? 'ba-step-active' : '']" @click="stepModal > 2 ? stepModal = 3 : ''">
                                        <i class='ba-step-icon'>
                                            <builderall-icon code='dd8e'></builderall-icon>
                                        </i>
                                        <span class='ba-step-title'>{{ t.label_confirmacao }}</span>
                                    </div>
                                </div>
                            </div>
                            <builderall-loader class="ba-content-main" :loading="loadingChangeEmail">
                                <div v-if="stepModal == 1" class="ba-flex ba-f-column ba-gp-1">
                                    <div class='ba-box-input ba-md'>
                                        <div class='ba-info'>
                                            <div class='ba-info-left'>
                                                <label class='ba-label' for='new_email'>{{ t.office2_info_modal_change_email_form_email }}</label>
                                            </div>
                                        </div>
                                        <input type='email' id='new_email' v-model="changeEmail.new_email" :class="['ba-input', !validateNewEmail ? 'ba-error' : '']" :placeholder="t.office2_info_modal_change_email_form_email+'...'" />
                                    </div>
                                    <div class='ba-box-input ba-md'>
                                        <div class='ba-info'>
                                            <div class='ba-info-left'>
                                                <label class='ba-label' for='password'>{{ t.office2_info_modal_change_email_form_senha }}</label>
                                            </div>
                                        </div>
                                        <input type='password' id='password' v-model="changeEmail.password" :class="['ba-input', !changeEmail.password ? 'ba-error' : '']" :placeholder="t.office2_info_modal_change_email_form_senha+'...'" />
                                    </div>
                                    <div class="ba-content-footer ba-flex ba-jc-fe">
                                        <button @click="defineStep(2)" :class="['ba-btn', 'ba-md', 'ba-blue', !validateNewEmail && !changeEmail.password ? 'ba-disabled' : '']" :disabled="!validateNewEmail && !changeEmail.password">
                                            {{ t.button_continuar }}
                                        </button>
                                    </div>
                                </div>
                                <div v-if="stepModal == 2" class="ba-flex ba-f-column ba-gp-1">
                                    <p class="ba6-p-element ba-text-center" v-text="t.office2_info_modal_change_email_form_code"></p>
                                    <ba6-code-inputs :getCodeInput="defineStep" :t="t" :setCode="defineCode" :qtyInputs="7" />
                                    <div class="ba-content-footer ba-flex ba-jc-fe">
                                        <button @click="defineStep(3)" :class="['ba-btn', 'ba-md', 'ba-blue', !validateChangeEmailCode ? 'ba-disabled' : '']" :disabled="!validateChangeEmailCode">
                                            {{ t.button_continuar }}
                                        </button>
                                    </div>
                                </div>
                                <div v-if="stepModal == 3" class="ba-flex ba-f-column ba-gp-1 ba-ai-center">
                                    <h2 class="ba-color-blue1 ba-montserrat-bold">{{ t.your_email_has_been_changed_successfully }}!</h2>
                                    <div class="ba-content-footer ba-flex ba-jc-fe ba-w-100">
                                        <button @click="toggleModal('ba6-modal-change-email')" class='ba-btn ba-md ba-blue'>
                                            {{ t.go_out }}
                                        </button>
                                    </div>
                                </div>
                            </builderall-loader>
                        </div>
                    </div>
                </ba6-modal>
                <div class='ba-info'>
                    <div class='ba-info-left'>
                        <label class='ba-label' for='email'>{{ t.email }}</label>
                    </div>
                </div>
                <div class='ba-box-input-icon'>
                    <input type='email' id='email' v-model="form.email" class="ba-input ba-disabled" :placeholder=' t.enter_your_email' disabled />
                    <div>
                        <button @click="toggleModal('ba6-modal-change-email')" class='ba-button'>
                            <builderall-icon code='edit' />
                        </button>
                    </div>
                </div>
            </div>
            <br>
            <div class='ba-box-input ba-md'>
                <div class='ba-info'>
                    <div class='ba-info-left'>
                        <label class='ba-label' for='phone'>{{ t.label_telefone }}</label> <builderall-icon class="ba6-phone-info-tooltip" code='info' ba-tooltip-position='bottom' :ba-tooltip-title="t.phone_information_edit_my_account"></builderall-icon>
                    </div>
                </div>
                <div :class="['ba-box-input-with-element', !form.phone ? 'ba-error' : '']">
                    <select v-model="form.country_code" name="country-codes" id="country-codes" class="ba-bi-element">
                        <option v-for="(c,i) in accountInfo.country_codes" :key="i" :value="c.code" v-text="'+' + c.code"></option>
                    </select>
                    <div class="ba-bi-box-input">
                        <input type='text' id="phone" :disabled="!form.country_code" :style="!form.country_code ? 'cursor:not-allowed;' : ''" v-model="form.phone" @input="form.phone = form.phone.replace(/\D/g, '').slice(0, 20)" :placeholder=' t.enter_your_phone_number ' />
                    </div>
                </div>
            </div>
            <br>
            <div class="ba-flex ba-gp-1">
                <div class='ba-box-input ba-md ba-w-100'>
                    <div class='ba-info'>
                        <div class='ba-info-left'>
                            <label class='ba-label' for='language'>{{ t.language }}</label>
                        </div>
                    </div>
                    <select class='ba-input ba-select ba-lg' v-model="form.language" name='language' id='language'>
                        <option v-for="(l,i) in langs" :key="i" :value="i" v-text="l"></option>
                    </select>
                </div>
                <div class='ba-box-input ba-md ba-w-100'>
                    <div class='ba-info'>
                        <div class='ba-info-left'>
                            <label class='ba-label' for='timezone'>{{ t.office_timezones_timezone }}</label>
                        </div>
                    </div>
                    <select class="ba-input ba-select ba-lg" v-model="form.timezone" name="timezone" id="timezone">
                        <optgroup v-for="(timezoneGroup, groupIndex) in timezones" :key="groupIndex" :label="timezoneGroup.label">
                            <option v-for="(option, optionIndex) in timezoneGroup.options" :key="optionIndex" :value="option.value">
                                {{ option.text }}
                            </option>
                        </optgroup>
                    </select>
                </div>
            </div>
        </builderall-loader>
    </div>
</template>

<script>
export default {
    name: "ba6-account-info",
    props: ['accountInfo','langs','timezones','routes','t'],
    data() {
        return {
            form: {
                name: this.accountInfo.user_data.nome,
                email: this.accountInfo.user_data.email_sanitized,
                country_code: this.accountInfo.user_data.country_code,
                phone: this.accountInfo.user_data.phone_number,
                language: this.accountInfo.user_data.pais,
                timezone: this.accountInfo.user_data.time_zone,
            },
            changeEmail: {
                new_email: null,
                password: null,
                code: null,
                status: false
            },
            stepModal: 1,
            loading: false,
            loadingChangeEmail: false,
            validateChangeEmailCode: false,
        }
    },
    methods: {
        saveForm(){
            if(this.validateGeralForm)
            {
                this.loading = true;

                const formData = new FormData();
                formData.append('cadastro_nome', this.form.name);
                formData.append('cadastro_telefone_pais', this.form.country_code);
                formData.append('cadastro_telefone', this.form.phone);
                formData.append('cadastro_pais', this.form.language);
                formData.append('select_timezone', this.form.timezone);

                axios
                    .post(this.routes.route_office_info, formData)
                    .then((response) => {
                        alertMsg('success', this.t.changed_with_successfully);
                        window.location.reload();
                    })
                    .catch((error) => {
                        alertMsg('error', error.response.data.message);
                    })
                    .finally(() => {
                        this.loading = false
                    })
            }
            else
            {
                alertMsg('error', this.t.complete_correctly_fields);
            }
        },
        defineStep(index){
            if(this.validateChangeEmailForm(this.stepModal))
            {
                this.loadingChangeEmail = true;

                const formData = new FormData();
                formData.append('new_email', this.changeEmail.new_email);
                formData.append('password', this.changeEmail.password);
                if(this.stepModal == 2)
                {
                    formData.append('code', this.changeEmail.code);
                }

                axios
                    .post(this.routes.route_office_info_change_email, formData)
                    .then((response) => {
                        if(response.data.status == "success")
                        {
                            this.stepModal = index;
                            if(index == 3)
                            {
                                setTimeout(() => {
                                    window.location.reload();
                                }, 2000);
                            }
                        }
                        else
                        {
                            alertMsg('error', response.data.message);
                        }
                    })
                    .catch((error) => {
                        alertMsg('error', error.message);
                    })
                    .finally(() => {
                        this.loadingChangeEmail = false
                    })
            }
            else
            {
                alertMsg('error', this.t.complete_correctly_fields);
            }
        },
        defineCode(validate, code){
            this.validateChangeEmailCode = validate;
            this.changeEmail.code = code;
        },
        validateChangeEmailForm(step){
            if(step == 1)
            {
                return this.validateNewEmail && this.changeEmail.password;
            }
            else if(step == 2)
            {
                return this.validateChangeEmailCode;
            }
            else
            {
                return true;
            }
        },
        toggleModal(data){
            $(`#${data}`).toggle('show');
            setTimeout(() => {
                this.stepModal = 1;
            }, 1000);
        },
    },
    computed: {
        validateNewEmail(){
            const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regexEmail.test(this.changeEmail.new_email);
        },
        validateGeralForm(){
            return !this.nameHasErrors && Object.values(this.form).every(v => v !== '');
        },
        nameHasErrors(){
            return !this.form.name || !(new RegExp(/^[A-Za-zÀ-ÖØ-öø-ÿÇç]{2,}(?:[-'][A-Za-zÀ-ÖØ-öø-ÿÇç]{2,})?(?:\s+[A-Za-zÀ-ÖØ-öø-ÿÇç\.]{2,}(?:[-'][A-Za-zÀ-ÖØ-öø-ÿÇç]{2,})?)+$/)).test(this.form.name)
        }
    }
};
</script>


<style scoped lang="scss">
    .ba6-account-info{
        display: flex;
        flex-direction: column;
        gap: 1rem;
    }
    .ba6-p-element{
        color: #4D5D71;
        font-size: 12px;
        font-weight: 500;
        letter-spacing: 0.66px;
    }

    .ba6-phone-info-tooltip{
      --builderall-icon-size: 22px;
      --builderall-icon-color: #0072e1;
      padding: 0px 5px 6px 7px;
    }

    .ba-bi-element{
      cursor:pointer;
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/routes/AccountInfo.vue